import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface ContactUsApiParameter {
    type?: string;
    emailTo?: string;
    name?: string;
    emailAddress?: string;
    phone?: string;
    city?: string;
    province?: string;
    requestType?: string;
    branch?: string | null;
    message?: string;
    language?: string;
}

const contactUsUrl = "/api/v1/communication";

export function contactUsService(parameter: ContactUsApiParameter) {
    return post<ContactUsApiParameter, void>(`${contactUsUrl}`, parameter);
}
